import {
    TOrderLimitsCodes,
    TOrderLimitsCodeType,
} from '@/src/modules/kyc/types'
import StyledErrorMessage from './StyledErrorMessage'

const getMessageText = (
    code: TOrderLimitsCodes | undefined,
    type: TOrderLimitsCodeType,
    over: number
) => {
    if (!code) {
        return <></>
    }

    const showDollar = type === TOrderLimitsCodeType.PURCHASE_AMOUNT
    if (code === TOrderLimitsCodes.ORDER_BREAKS_WEEK_LIMIT) {
        return (
            <>
                You are over your weekly guest checkout limit for{' '}
                {type.replace('-', ' ')} by {showDollar ? '$' : ''}
                {over}. To proceed, remove items from your cart. If you wish to
                continue with this purchase as is, you must login and provide a
                little more information.
            </>
        )
    }
    if (code === TOrderLimitsCodes.ORDER_BREAKS_KYC_WEEK_LIMIT) {
        return (
            <>
                You are over your weekly limit for {type.replace('-', ' ')} by{' '}
                {showDollar ? '$' : ''}
                {over}. To proceed, remove items from your cart.
            </>
        )
    }
    if (code === TOrderLimitsCodes.KYC_OVER_WEEK_LIMIT) {
        return (
            <>
                You are over your weekly limit for {type.replace('-', ' ')}. You
                will have to wait in order to purchase more.
            </>
        )
    }
    if (code === TOrderLimitsCodes.OVER_WEEK_LIMIT) {
        return (
            <>
                You are over your limit for guest checkout{' '}
                {type.replace('-', ' ')} for the week. If you wish to continue
                with this purchase as is, you must login and provide a little
                more information.
            </>
        )
    }
}

const OverLimitsAlertCheckout = ({
    overLimitAmount,
    overLimitType,
    overLimitCodeType,
}: {
    overLimitAmount: number
    overLimitType: TOrderLimitsCodeType
    overLimitCodeType?: TOrderLimitsCodes
}) => {
    return (
        <StyledErrorMessage
            errorText={getMessageText(
                overLimitCodeType,
                overLimitType,
                overLimitAmount
            )}
        />
    )
}

export default OverLimitsAlertCheckout
